<template>
  <!-- Page content -->
  <div class="console-content">
    <router-view></router-view>
    <section class="register-footer" v-if="region === 'uk'">
      <Alerts></Alerts>
      <!--<Messages></Messages>-->
      <FooterUK class="register-page__footer"></FooterUK>
    </section>
    <section class="register-footer" v-else-if="region === 'forex'">
      <Alerts></Alerts>
      <!--<Messages></Messages>-->
      <FooterForex class="register-page__footer"></FooterForex>
    </section>
    <section class="register-footer" v-else-if="region === 'latam'">
      <Alerts></Alerts>
      <!--<Messages></Messages>-->
      <FooterLatam class="register-page__footer"></FooterLatam>
    </section>
    <section class="register-footer" v-else-if="region === 'mena'">
      <Alerts></Alerts>
      <!--<Messages></Messages>-->
      <FooterMena class="register-page__footer"></FooterMena>
    </section>
    <section class="register-footer" v-else>
      <Alerts></Alerts>
      <!--<Messages></Messages>-->
      <FooterForex class="register-page__footer"></FooterForex>
    </section>
  </div>
</template>

<script>
import { ref } from "vue";
import FooterUK from "./uk/FooterUK.vue";
import FooterForex from "./forex/FooterForex.vue";
import FooterMena from "./mena/FooterMena.vue";
import FooterLatam from "./latam/FooterLatam.vue";
import Messages from "@/components/Messages";
import Alerts from "@/components/Alerts";

export default {
  name: "ConsoleContent",

  setup() {
    const region = ref(process.env.VUE_APP_CABINET_ORIGIN);
    return {
      region,
    };
  },
  components: {
    Messages,
    FooterUK,
    FooterForex,
    FooterLatam,
    FooterMena,
    Alerts,
  },
};
</script>

<style scoped>
</style>